import {Model} from "@vuex-orm/core";

export default class ProposalProductAlternativeDossierTraveller extends Model {

    static entity = 'proposalProductAlternativeDossierTraveller';

    static primaryKey = ['proposal_product_alternative_id', 'dossier_traveller_id'];

    static fields () {
        return {
            proposal_product_alternative_id: this.number(null),
            dossier_traveller_id: this.number(null),
        }
    }
}
